/* unplugin-vue-components disabled */import script from "./SettingItem.vue?vue&type=script&lang=ts&setup=true"
export * from "./SettingItem.vue?vue&type=script&lang=ts&setup=true"

import "./SettingItem.vue?vue&type=style&index=0&id=0ba5ab7a&lang=scss&scoped=true"

import exportComponent from "/var/static/node_modules/.pnpm/vue-loader@16.8.3_@vue+compiler-sfc@3.3.4_vue@3.3.4_webpack@4.46.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0ba5ab7a"]])

export default __exports__